import React from 'react';

const Input = ({ value, onChange, placeholder = '', className = '', ...props }) => {
 return (
 <input
 value={value}
 onChange={onChange}
 placeholder={placeholder}
 className={`px-4 py-2 border border-gray-300 rounded-xl bg-white text-black w-full focus:outline-none focus:ring-2 focus:ring-yellow-400 ${className}`}
 {...props}
 />
 );
};

export default Input;



